import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

import One from "../images/one.svg"
import Two from "../images/two.svg"

import { Link, graphql } from "gatsby"

const Reviews = () => (
  <Layout>
    <SEO
      title="Reviews"
      description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    />
    <div className="container-fluid page-head about-us text-center">
      <div className="container p-relative page-heading">
        <div>
          <h1 className="inner-page-h1 font-weight-bold">Reviews</h1>
          <h2 className="mt-0">Helping you pay attention to your intention.</h2>
        </div>
      </div>
      <div className="row heading-blocks" />
    </div>
    <div className="container-fluid page-body">
      <div className="custom-container">
        <div className="section-one">
          <div className="row">
            <div className="col-lg-6">
              <div className="review-container">
                <p>
                  "[Todd] saved us countless hours of frustration and the
                  project thousands of dollars by helping us avoid dead ends and
                  accelerating our learning curve."
                </p>
                <p>
                  <em>John Minter / CEO</em>
                </p>
              </div>
              <div className="review-container">
                <p>
                  "A phenomenal asset to any business from an employee
                  perspective. I’ve appreciated Todd’s focus on culture within a
                  company, addressing and successfully aiding in resolving
                  aspects of a team/business that are often overlooked. He is
                  easy to speak with; open and honestly. Todd has inspired me to
                  think about ways to better myself - not only professionally
                  but personally. He reminds us of the priorities of a work
                  environment, always remembering the humanity that is needed to
                  keep the wheels spinning for the employee and business alike."
                </p>
                <p>
                  <em>
                    Kimberly Gonzalez / Office Manager / McAllister Garfield Law
                  </em>
                </p>
              </div>
              <div className="review-container">
                <p>
                  "I enjoy and value every conversation I have with Todd. He's a
                  deep thinker with great insights. I always walk away with new
                  ideas, new questions, and new answers. I like his
                  straight-talk style coupled with immense empathy. Todd's the
                  Real deal."
                </p>
                <p>
                  <em>
                    Frannie Matthews / CEO / Colorado Technology Association
                  </em>
                </p>
              </div>

              <div className="review-container">
                <p>
                  Todd has assisted us with everything from determining what
                  area of focus we are going to hone in on, understanding the
                  psychology of how major corporations make decisions, preparing
                  sales presentations to meet clients’ needs, to planning for
                  the future growth of our business. The information that we
                  have gained has far exceeded our expectations. After each
                  consultation, we are amazed by the amount of information that
                  Todd has taught and provided us within an hour session and the
                  confidence that we have gained through these sessions.
                  Deciding to hire a consultant was a tough decision for us, as
                  we have very limited funds as a start-up company. It is the
                  best decision that we have made to date.
                </p>
                <p>
                  <em>Jessica Kaiser / Founder / Canna Demos</em>
                </p>
              </div>
              <div className="review-container">
                <p>
                  Todd Wheeler at Management Insight has worked with me for 6
                  months prior to the world pandemic. I contacted Todd in the
                  summer of 2019 as an old friend who could coach me into my
                  next personal and business phase of my entertainment company
                </p>
                <p>
                  Todd kept me focused on my business by first focusing on the
                  importance of personal balance. We focused on important family
                  and friends and a balanced view that removed unimportant
                  distractions and habits. We focused on life balance
                  physically, emotionally and spiritually. Balance and
                  perspective on where you have been, who you are and where you
                  are going is important in finding a sense of purpose.
                </p>
                <p>
                  Todd got me in touch with my sense of purpose. The balance and
                  purpose set the basics for reenergizing my business plan.
                </p>
                <p>
                  I continue to rely on Todd's considerable expertise and advice
                  and wisdom as my company takes its next leap into a successful
                  future.
                </p>
                <p>
                  I confidently and strongly recommend Todd Wheeler and
                  Management Insight to any serious business leader or any
                  individual looking for life balance.
                </p>
                <p>
                  <em>
                    Jerry Barnette / President / Moments Notice Entertainment,
                    Inc
                  </em>
                </p>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="review-container">
                <p>
                  "I knew day one that Todd was an asset. His 'secret power' is
                  active listening. This allows him to assist in personal,
                  structural and organizational decisions from a place of
                  understanding. Todd taught me in the first week how to hook
                  "Difficult customers". I was shocked by how well his tactics
                  worked. He saved me so much time in meetings (which were the
                  majority of my headaches) and I learned how to get a signed
                  contract with a long commitment after only one in-person
                  meeting. Thank you Todd!"
                </p>
                <p>
                  <em>Jennell Carter / Founder</em>
                </p>
              </div>
              <div className="review-container">
                <p>
                  "I have streamlined my life and am very grateful for the
                  insight Todd Wheeler has given me. Some of the major
                  accomplishments I have been blessed to achieve since
                  implementing this process was buying my first home and
                  finishing my first novel. Mr. Wheeler's presentation helped
                  make it possible to keep all of the balls in the air, so to
                  speak."
                </p>
                <p>
                  <em>Ukela Alred / CEO & Founder</em>
                </p>
              </div>
              <div className="review-container">
                <p>
                  "Your philosophy and mind set was just what I needed to take
                  me to the next level."
                </p>
                <p>
                  <em>Brooke Milburn / CEO of Go-To-Gals Concierge, LLC</em>
                </p>
              </div>
              <div className="review-container">
                <p>
                  "Imagine your favorite sports team or athlete without a coach.
                  The results would likely not be great. The same goes for
                  business – why do you think most of them fail? Todd Wheeler
                  brings decades of business coaching to the table. If you
                  desire top performance amongst your leadership and team, he
                  needs to be your next call."
                </p>
                <p>
                  <em>Greg Frye / Copy-Writer and Journalist</em>
                </p>
              </div>
              <div className="review-container">
                <p>
                  "Our pr/ad agency has worked with Todd and his team for five
                  years now. He has helped us with everything from overall
                  strategy and operational alignment to business development and
                  executive leadership training. In the simplest of terms, Todd
                  just gets it. And that's the point. He is able to approach
                  complex situations, analyze them and offer practical solutions
                  that even a small family business like ours can implement. He
                  is a pleasure to work with and his desire to help his clients
                  succeed is as sincere as you ever could dream of receiving
                  from a consultant."
                </p>
                <p>
                  <em>
                    David and Diane Eichler / Decibel Blue Advertising and PR
                  </em>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default Reviews
